module.exports = __webpack_public_path__ + "static/media/fan1_lamp0.0ee0cd8d.gif";